import numeral from 'numeral';

const convertRate = 0.45359237;

export const convertLbsToGrams = lbs => {
  // make sure its a number

  const kg = parseFloat(lbs) * convertRate;
  const grams = Math.round(kg * 1000);
  return grams;
};

export const convertGramsToLbs = grams => {
  const kg = grams / 1000;
  const lbs = kg / convertRate;
  return numeral(lbs).format('0.00');
};



// WEBPACK FOOTER //
// ./app/utils/weight.js